import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Solutions from "./components/Solutions";
import FeaturedWork from "./components/FeaturedWork";
import WhyDotCreate from "./components/WhyDotCreate";
import Process from "./components/Process";
import TargetAudience from "./components/TargetAudience";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <Hero />
      <About />
      <Solutions />
      <FeaturedWork />
      <WhyDotCreate />
      <Process />
      <TargetAudience />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
